const publicUrl = "https://istar-bucket.s3.ap-southeast-2.amazonaws.com";
// process.env?.NODE_ENV === "development"
//   ? "http://localhost:3000"
//   : "https://istarhearing.com";
// __________________Left Tune_________________
export const LeftTracks500 = [
  {
    id: 1,
    url: `${publicUrl}/audio/500_Hz_Left_ear/500_20_L.mp3`,
    title: "Blues Beat",
    db: 20,
  },
  {
    id: 2,
    url: `${publicUrl}/audio/500_Hz_Right_Ear/500_30R.mp3`,
    title: "Blues Beat",
    db: 30,
  },
  {
    id: 3,
    url: `${publicUrl}/audio/500_Hz_Right_Ear/500_40R.mp3`,
    title: "20db",
    db: 40,
  },
  {
    id: 4,
    url: `${publicUrl}/audio/500_Hz_Right_Ear/500_50R.mp3`,
    title: "Blues Beat",
    db: 50,
  },
  {
    id: 5,
    url: `${publicUrl}/audio/500_Hz_Right_Ear/500_60R.mp3`,
    title: "Blues Beat",
    db: 60,
  },
  {
    id: 6,
    url: `${publicUrl}/audio/500_Hz_Right_Ear/500_70R.mp3`,
    title: "Blues Beat",
    db: 70,
  },
  {
    id: 7,
    url: `${publicUrl}/audio/500_Hz_Right_Ear/500_80R.mp3`,
    title: "Blues Beat",
    db: 80,
  },
];

export const LeftTracks1000 = [
  {
    id: 1,
    url: `${publicUrl}/audio/1000_Hz_Right_Ear/1000_20_R.mp3`,
    title: "Blues Beat",
    db: 20,
  },
  {
    id: 2,
    url: `${publicUrl}/audio/1000_Hz_Right_Ear/1000_30_R.mp3`,
    title: "Blues Beat",
    db: 30,
  },
  {
    id: 3,
    url: `${publicUrl}/audio/1000_Hz_Right_Ear/1000_40_R.mp3`,
    title: "Blues Beat",
    db: 40,
  },
  {
    id: 4,
    url: `${publicUrl}/audio/1000_Hz_Right_Ear/1000_50_R.mp3`,
    title: "Blues Beat",
    db: 50,
  },
  {
    id: 5,
    url: `${publicUrl}/audio/1000_Hz_Right_Ear/1000_60_R.mp3`,
    title: "Blues Beat",
    db: 60,
  },
  {
    id: 6,
    url: `${publicUrl}/audio/1000_Hz_Right_Ear/1000_70_R.mp3`,
    title: "Blues Beat",
    db: 70,
  },
  {
    id: 7,
    url: `${publicUrl}/audio/1000_Hz_Right_Ear/1000_80_R.mp3`,
    title: "Blues Beat",
    db: 80,
  },
];

export const LeftTracks2000 = [
  {
    id: 1,
    url: `${publicUrl}/audio/2000_Hz_Right_Ear/2000_20_R.mp3`,
    title: "Blues Beat",
    db: 20,
  },
  {
    id: 2,
    url: `${publicUrl}/audio/2000_Hz_Right_Ear/2000_30_R.mp3`,
    title: "Blues Beat",
    db: 30,
  },
  {
    id: 3,
    url: `${publicUrl}/audio/2000_Hz_Right_Ear/2000_40_R.mp3`,
    title: "Blues Beat",
    db: 40,
  },
  {
    id: 4,
    url: `${publicUrl}/audio/2000_Hz_Right_Ear/2000_50_R.mp3`,
    title: "Blues Beat",
    db: 50,
  },
  {
    id: 5,
    url: `${publicUrl}/audio/2000_Hz_Right_Ear/2000_60_R.mp3`,
    title: "Blues Beat",
    db: 60,
  },
  {
    id: 6,
    url: `${publicUrl}/audio/2000_Hz_Right_Ear/2000_70_R.mp3`,
    title: "Blues Beat",
    db: 70,
  },
  {
    id: 7,
    url: `${publicUrl}/audio/2000_Hz_Right_Ear/2000_80_R.mp3`,
    title: "Blues Beat",
    db: 80,
  },
];

export const LeftTracks3000 = [
  {
    id: 1,
    url: `${publicUrl}/audio/3000_Hz_Right_Ear/3000_20_R.mp3`,
    title: "Blues Beat",
    db: 20,
  },
  {
    id: 2,
    url: `${publicUrl}/audio/3000_Hz_Right_Ear/3000_30_R.mp3`,
    title: "Blues Beat",
    db: 30,
  },
  {
    id: 3,
    url: `${publicUrl}/audio/3000_Hz_Right_Ear/3000_40_R.mp3`,
    title: "Blues Beat",
    db: 40,
  },
  {
    id: 4,
    url: `${publicUrl}/audio/3000_Hz_Right_Ear/3000_50_R.mp3`,
    title: "Blues Beat",
    db: 50,
  },
  {
    id: 5,
    url: `${publicUrl}/audio/3000_Hz_Right_Ear/3000_60_R.mp3`,
    title: "Blues Beat",
    db: 60,
  },
  {
    id: 6,
    url: `${publicUrl}/audio/3000_Hz_Right_Ear/3000_70_R.mp3`,
    title: "Blues Beat",
    db: 70,
  },
  {
    id: 7,
    url: `${publicUrl}/audio/3000_Hz_Right_Ear/3000_80_R.mp3`,
    title: "Blues Beat",
    db: 80,
  },
];

export const LeftTracks4000 = [
  {
    id: 1,
    url: `${publicUrl}/audio/4000_Hz_Right_Ear/4000_20_R.mp3`,
    title: "Blues Beat",
    db: 20,
  },
  {
    id: 2,
    url: `${publicUrl}/audio/4000_Hz_Right_Ear/4000_30_R.mp3`,
    title: "Blues Beat",
    db: 30,
  },
  {
    id: 3,
    url: `${publicUrl}/audio/4000_Hz_Right_Ear/4000_40_R.mp3`,
    title: "Blues Beat",
    db: 40,
  },
  {
    id: 4,
    url: `${publicUrl}/audio/4000_Hz_Right_Ear/4000_50_R.mp3`,
    title: "Blues Beat",
    db: 50,
  },
  {
    id: 5,
    url: `${publicUrl}/audio/4000_Hz_Right_Ear/4000_60_R.mp3`,
    title: "Blues Beat",
    db: 60,
  },
  {
    id: 6,
    url: `${publicUrl}/audio/4000_Hz_Right_Ear/4000_70_R.mp3`,
    title: "Blues Beat",
    db: 70,
  },
  {
    id: 7,
    url: `${publicUrl}/audio/4000_Hz_Right_Ear/4000_80_R.mp3`,
    title: "Blues Beat",
    db: 80,
  },
];

export const LeftTracks6000 = [
  {
    id: 1,
    url: `${publicUrl}/audio/6000_Hz_Right_Ear/6000_20_R.mp3`,
    title: "Blues Beat",
    db: 20,
  },
  {
    id: 2,
    url: `${publicUrl}/audio/6000_Hz_Right_Ear/6000_30_R.mp3`,
    title: "Blues Beat",
    db: 20,
  },
  {
    id: 3,
    url: `${publicUrl}/audio/6000_Hz_Right_Ear/6000_40_R.mp3`,
    title: "Blues Beat",
    db: 30,
  },
  {
    id: 4,
    url: `${publicUrl}/audio/6000_Hz_Right_Ear/6000_50_R.mp3`,
    title: "Blues Beat",
    db: 40,
  },
  {
    id: 5,
    url: `${publicUrl}/audio/6000_Hz_Right_Ear/6000_60_R.mp3`,
    title: "Blues Beat",
    db: 50,
  },
  {
    id: 6,
    url: `${publicUrl}/audio/6000_Hz_Right_Ear/6000_70_R.mp3`,
    title: "Blues Beat",
    db: 60,
  },
  {
    id: 7,
    url: `${publicUrl}/audio/6000_Hz_Right_Ear/6000_80_R.mp3`,
    title: "Blues Beat",
    db: 70,
  },
];
// __________________Right Tune_________________
export const RightTracks500 = [
  {
    id: 1,
    url: `${publicUrl}/audio/500_Hz_Left_ear/500_20_L.mp3`,
    title: "Blues Beat",
    db: 20,
  },

  {
    id: 2,
    url: `${publicUrl}/audio/500_Hz_Left_ear/500_30_L.mp3`,
    title: "Blues Beat",
    db: 30,
  },
  {
    id: 3,
    url: `${publicUrl}/audio/500_Hz_Left_ear/500_40_L.mp3`,
    title: "Blues Beat",
    db: 40,
  },
  {
    id: 4,
    url: `${publicUrl}/audio/500_Hz_Left_ear/500_50_L.mp3`,
    title: "Blues Beat",
    db: 50,
  },
  {
    id: 5,
    url: `${publicUrl}/audio/500_Hz_Left_ear/500_60_L.mp3`,
    title: "Blues Beat",
    db: 60,
  },
  {
    id: 6,
    url: `${publicUrl}/audio/500_Hz_Left_ear/500_70_L.mp3`,
    title: "Blues Beat",
    db: 70,
  },
  {
    id: 7,
    url: `${publicUrl}/audio/500_Hz_Left_ear/500_80_L.mp3`,
    title: "Blues Beat",
    db: 80,
  },
];

export const RightTracks1000 = [
  {
    id: 1,
    url: `${publicUrl}/audio/1000_Hz_Left_Ear/1000_20_L.mp3`,
    title: "Blues Beat",
    db: 20,
  },
  {
    id: 2,
    url: `${publicUrl}/audio/1000_Hz_Left_Ear/1000_30_L.mp3`,
    title: "Blues Beat",
    db: 30,
  },
  {
    id: 3,
    url: `${publicUrl}/audio/1000_Hz_Left_Ear/1000_40_L.mp3`,
    title: "Blues Beat",
    db: 40,
  },
  {
    id: 4,
    url: `${publicUrl}/audio/1000_Hz_Left_Ear/1000_50_L.mp3`,
    title: "Blues Beat",
    db: 50,
  },
  {
    id: 5,
    url: `${publicUrl}/audio/1000_Hz_Left_Ear/1000_60_L.mp3`,
    title: "Blues Beat",
    db: 60,
  },
  {
    id: 6,
    url: `${publicUrl}/audio/1000_Hz_Left_Ear/1000_70_L.mp3`,
    title: "Blues Beat",
    db: 70,
  },
  {
    id: 7,
    url: `${publicUrl}/audio/1000_Hz_Left_Ear/1000_80_L.mp3`,
    title: "Blues Beat",
    db: 80,
  },
];

export const RightTracks2000 = [
  {
    id: 1,
    url: `${publicUrl}/audio/2000_Hz_Left_Ear/2000_20_L.mp3`,
    title: "Blues Beat",
    db: 20,
  },
  {
    id: 2,
    url: `${publicUrl}/audio/2000_Hz_Left_Ear/2000_30_L.mp3`,
    title: "Blues Beat",
    db: 30,
  },
  {
    id: 3,
    url: `${publicUrl}/audio/2000_Hz_Left_Ear/2000_40_L.mp3`,
    title: "Blues Beat",
    db: 40,
  },
  {
    id: 4,
    url: `${publicUrl}/audio/2000_Hz_Left_Ear/2000_50_L.mp3`,
    title: "Blues Beat",
    db: 50,
  },
  {
    id: 5,
    url: `${publicUrl}/audio/2000_Hz_Left_Ear/2000_60_L.mp3`,
    title: "Blues Beat",
    db: 60,
  },
  {
    id: 6,
    url: `${publicUrl}/audio/2000_Hz_Left_Ear/2000_70_L.mp3`,
    title: "Blues Beat",
    db: 70,
  },
  {
    id: 7,
    url: `${publicUrl}/audio/2000_Hz_Left_Ear/2000_80_L.mp3`,
    title: "Blues Beat",
    db: 80,
  },
];

export const RightTracks3000 = [
  {
    id: 1,
    url: `${publicUrl}/audio/3000_Hz_Left_Ear/3000_20_L.mp3`,
    title: "Blues Beat",
    db: 20,
  },
  {
    id: 2,
    url: `${publicUrl}/audio/3000_Hz_Left_Ear/3000_30_L.mp3`,
    title: "Blues Beat",
    db: 30,
  },
  {
    id: 3,
    url: `${publicUrl}/audio/3000_Hz_Left_Ear/3000_40_L.mp3`,
    title: "Blues Beat",
    db: 40,
  },
  {
    id: 4,
    url: `${publicUrl}/audio/3000_Hz_Left_Ear/3000_50_L.mp3`,
    title: "Blues Beat",
    db: 50,
  },
  {
    id: 5,
    url: `${publicUrl}/audio/3000_Hz_Left_Ear/3000_60_L.mp3`,
    title: "Blues Beat",
    db: 60,
  },
  {
    id: 6,
    url: `${publicUrl}/audio/3000_Hz_Left_Ear/3000_70_L.mp3`,
    title: "Blues Beat",
    db: 70,
  },
  {
    id: 7,
    url: `${publicUrl}/audio/3000_Hz_Left_Ear/3000_80_L.mp3`,
    title: "Blues Beat",
    db: 80,
  },
];

export const RightTracks4000 = [
  {
    id: 1,
    url: `${publicUrl}/audio/4000_Hz_Left_Ear/4000_20_L.mp3`,
    title: "Blues Beat",
    db: 20,
  },
  {
    id: 2,
    url: `${publicUrl}/audio/4000_Hz_Left_Ear/4000_30_L.mp3`,
    title: "Blues Beat",
    db: 30,
  },
  {
    id: 3,
    url: `${publicUrl}/audio/4000_Hz_Left_Ear/4000_40_L.mp3`,
    title: "Blues Beat",
    db: 40,
  },
  {
    id: 4,
    url: `${publicUrl}/audio/4000_Hz_Left_Ear/4000_50_L.mp3`,
    title: "Blues Beat",
    db: 50,
  },
  {
    id: 5,
    url: `${publicUrl}/audio/4000_Hz_Left_Ear/4000_60_L.mp3`,
    title: "Blues Beat",
    db: 60,
  },
  {
    id: 6,
    url: `${publicUrl}/audio/4000_Hz_Left_Ear/4000_70_L.mp3`,
    title: "Blues Beat",
    db: 70,
  },
  {
    id: 7,
    url: `${publicUrl}/audio/4000_Hz_Left_Ear/4000_80_L.mp3`,
    title: "Blues Beat",
    db: 80,
  },
];

export const RightTracks6000 = [
  {
    id: 1,
    url: `${publicUrl}/audio/6000_Hz_Left_Ear/6000_20_L.mp3`,
    title: "Blues Beat",
    db: 20,
  },
  {
    id: 2,
    url: `${publicUrl}/audio/6000_Hz_Left_Ear/6000_30_L.mp3`,
    title: "Blues Beat",
    db: 30,
  },
  {
    id: 3,
    url: `${publicUrl}/audio/6000_Hz_Left_Ear/6000_40_L.mp3`,
    title: "Blues Beat",
    db: 40,
  },
  {
    id: 4,
    url: `${publicUrl}/audio/6000_Hz_Left_Ear/6000_50_L.mp3`,
    title: "Blues Beat",
    db: 50,
  },
  {
    id: 5,
    url: `${publicUrl}/audio/6000_Hz_Left_Ear/6000_60_L.mp3`,
    title: "Blues Beat",
    db: 60,
  },
  {
    id: 6,
    url: `${publicUrl}/audio/6000_Hz_Left_Ear/6000_70_L.mp3`,
    title: "Blues Beat",
    db: 70,
  },
  {
    id: 7,
    url: `${publicUrl}/audio/6000_Hz_Left_Ear/6000_80_L.mp3`,
    title: "Blues Beat",
    db: 80,
  },
];

export const KUSU = [
  {
    id: 1,
    url: `${publicUrl}/kusu.mp3`,
    title: "Blues Beat",
    db: 20,
  },
];

export const S3 = [
  {
    id: 1,
    url: `https://altcabs.s3.eu-west-2.amazonaws.com/hypermarket/500_60_L.mp3`,
    title: "Blues Beat",
    db: 20,
  },
  {
    id: 2,
    url: `https://altcabs.s3.eu-west-2.amazonaws.com/hypermarket/1000_50_R.mp3`,
    title: "Blues Beat",
    db: 20,
  },
  {
    id: 3,
    url: `https://altcabs.s3.eu-west-2.amazonaws.com/hypermarket/4000_80_R.mp3`,
    title: "Blues Beat",
    db: 20,
  },

  {
    id: 4,
    url: `https://altcabs.s3.eu-west-2.amazonaws.com/hypermarket/6000_80_L.mp3`,
    title: "Blues Beat",
    db: 20,
  },
];
